import { initializeApp } from 'firebase/app';
import { getFirestore, connectFirestoreEmulator } from 'firebase/firestore';
import { getFunctions, connectFunctionsEmulator } from 'firebase/functions';
import { getAuth, connectAuthEmulator } from 'firebase/auth';
import { initializeAppCheck, ReCaptchaV3Provider } from 'firebase/app-check';

// Firebase configuration
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "demo-key",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "demo-project.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "demo-project",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "demo-project.appspot.com",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "123456789",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:123456789:web:abcdef123456",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize App Check for production security
let appCheck: any = null;
if (process.env.NODE_ENV === 'production' && process.env.REACT_APP_RECAPTCHA_SITE_KEY) {
  try {
    appCheck = initializeAppCheck(app, {
      provider: new ReCaptchaV3Provider(process.env.REACT_APP_RECAPTCHA_SITE_KEY),
      isTokenAutoRefreshEnabled: true
    });
    console.log('🛡️ App Check initialized for production');
  } catch (error) {
    console.error('Failed to initialize App Check:', error);
  }
} else if (process.env.NODE_ENV === 'development') {
  // For development/emulator, set debug token if available
  if (process.env.REACT_APP_APPCHECK_DEBUG_TOKEN) {
    (window as any).FIREBASE_APPCHECK_DEBUG_TOKEN = process.env.REACT_APP_APPCHECK_DEBUG_TOKEN;
    console.log('🛡️ App Check debug mode enabled');
  }
}

// Initialize Firebase services
// NOTE: db is not exported to prevent direct database access from frontend
const db = getFirestore(app);
export const functions = getFunctions(app, 'us-central1');
export const auth = getAuth(app);
export { appCheck };

// Connect to emulators ONLY in development mode
// Check if we're in development by looking at hostname and environment
// const isLocalhost = window.location.hostname === 'localhost' || 
//                    window.location.hostname === '127.0.0.1';
// const isDev = process.env.NODE_ENV === 'development' && isLocalhost;

// Force production mode - disable emulators
const isLocalhost = false;
const isDev = false;

console.log('🔍 Environment check:', {
  NODE_ENV: process.env.NODE_ENV,
  hostname: window.location.hostname,
  isLocalhost,
  isDev
});

if (isDev) {
  const isEmulatorConnected = {
    firestore: false,
    functions: false,
    auth: false,
  };

  // Connect to Firestore emulator
  if (!isEmulatorConnected.firestore) {
    try {
      connectFirestoreEmulator(db, 'localhost', 8080);
      isEmulatorConnected.firestore = true;
      console.log('🔥 Connected to Firestore emulator');
    } catch (error) {
      console.log('📡 Firestore emulator connection failed:', error);
    }
  }

  // Connect to Functions emulator
  if (!isEmulatorConnected.functions) {
    try {
      connectFunctionsEmulator(functions, 'localhost', 5001);
      isEmulatorConnected.functions = true;
      console.log('⚡ Connected to Functions emulator');
    } catch (error) {
      console.log('📡 Functions emulator connection failed:', error);
    }
  }

  // Connect to Auth emulator
  if (!isEmulatorConnected.auth) {
    try {
      connectAuthEmulator(auth, 'http://localhost:9099', { disableWarnings: true });
      isEmulatorConnected.auth = true;
      console.log('🔐 Connected to Auth emulator');
    } catch (error) {
      console.log('📡 Auth emulator connection failed:', error);
    }
  }
} else {
  console.log('🌐 Using production Firebase services');
}

export default app;